import React from "react";

import { TEMPLATE_FOUR_DEFAULTS } from "@/utils/template4Theme";

export interface WarrantyFooterProps {
  /** Nội dung chân trang — cấu hình ở template `mrw_template_4` (khoá `footer_text`). */
  footerText?: string;
  /** Số tổng đài — khoá `hotline` của template. */
  hotline?: string;
}

/** Footer clone từ app cũ baohanh-barcode (components/Footer.vue). */
const WarrantyFooter: React.FC<WarrantyFooterProps> = ({ footerText, hotline }) => (
  <div className="baohanh-footer">
    <div className="gp-footer-text text-center mt-6 px-2">
      <div className="whitespace-pre-line">{footerText || TEMPLATE_FOUR_DEFAULTS.footer_text}</div>
      <div>Số điện thoại: {hotline || TEMPLATE_FOUR_DEFAULTS.hotline}</div>
    </div>
  </div>
);

export default WarrantyFooter;
